import { apiFetch } from './client';

export interface ListParams {
  select?: string;
  order?: string;
  limit?: number;
  offset?: number;
  [key: string]: string | number | boolean | undefined;
}

function buildQuery(params: ListParams): string {
  const parts: string[] = [];
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined) {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
    }
  }
  return parts.length > 0 ? `?${parts.join('&')}` : '';
}

export async function listResource<T = any>(
  table: string,
  params: ListParams = {},
): Promise<{ data: T[]; count: number }> {
  const query = buildQuery(params);
  const result = await apiFetch<{ items: T[]; total: number }>(
    `/resource/${encodeURIComponent(table)}${query}`,
  );
  return { data: result.items, count: result.total };
}

export async function getResource<T = any>(
  table: string,
  id: string,
  params: Pick<ListParams, 'select'> = {},
): Promise<T> {
  const query = buildQuery(params);
  return apiFetch(`/resource/${encodeURIComponent(table)}/${encodeURIComponent(id)}${query}`);
}

export async function createResource<T = any>(
  table: string,
  data: Record<string, any>,
): Promise<T> {
  return apiFetch(`/resource/${encodeURIComponent(table)}`, {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export async function updateResource<T = any>(
  table: string,
  id: string,
  data: Record<string, any>,
): Promise<T> {
  return apiFetch(`/resource/${encodeURIComponent(table)}/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

export async function deleteResource(
  table: string,
  id: string,
): Promise<void> {
  await apiFetch(`/resource/${encodeURIComponent(table)}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
  });
}
